export const ToggleMessageTypeName = {
MT: {
    messageType:"MT N°",
    field20: "Field 20: Reference Number",
    field: "Field N°",
    headerTitle:"Header Information",
    customer50:"50A: Ordering Customer",
    customer59:"59A: Beneficiary Customer",
    customer56:"56A Intermediary Bank",
    customer52:"52A Ordering Institution",
    customer57:"57A Account with Institution",
    customer54:"54A Receiver's Correspondent",
    customer53:"53A Sender's Correspondent",
    receiver:"Receiver",
    sender:"Sender",
    MUR:"108 (MUR)"
} ,

MX : {
    messageType:"Message Type",
    field20:"Message identification",
    field:"Element",
    headerTitle:"Data PDU",
    customer50:"Debtor Agent",
    customer59:"Creditor Agent",
    customer56:"Intermediary Agent",
    customer52:"Debtor Agent",
    customer57:"Creditor Agent",
    customer54:"Instructed Reimbursement Agent",
    customer53:"Instructing Reimbursement Agent Account",
    receiver:"Creditor",
    sender:"Debtor", 
    MUR:"MUR"  
}
}